module.exports = __webpack_public_path__ + "img/notFound.a3dceac5.svg";